$(document).ready(function() {

    // === MOBILE MENU TOGGLE FUNCTIONALITY ===
    $('#mobileMenuToggle').on('click', function(e) {
        e.preventDefault();
        $('#mobileMenuFullscreen').addClass('active');
        $('body').css('overflow', 'hidden'); // Prevent scrolling when menu is open
    });

    $('#mobileMenuClose').on('click', function(e) {
        e.preventDefault();
        $('#mobileMenuFullscreen').removeClass('active');
        $('body').css('overflow', 'auto'); // Re-enable scrolling
    });

    // Close menu when clicking on a menu item
    $('.mobile-menu-item').on('click', function() {
        setTimeout(function() {
            $('#mobileMenuFullscreen').removeClass('active');
            $('body').css('overflow', 'auto');
        }, 300);
    });

    // === RENDER SPORTS VENUES ===


    // === FILTER FUNCTIONALITY ===
    function filterVenues() {

        let searchTerm = $('#homepageSearchInput').val().toLowerCase();

        searchTerm = searchTerm.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

        const activeLocationFilters = $('.location-filter:checked').map(function() {
            return $(this).val();
        }).get();

        const activeSurfaceFilters = $('.surface-filter:checked').map(function() {
            return $(this).val();
        }).get();

        let venues = $('.js-venue-loop-item');

        venues.each(function(index, venue) {

            let venue_object = $(venue);

            venue_object.hide();

            let show = true;

            if(searchTerm){

                let venue_title = venue_object.data('title');
                let venue_address = venue_object.data('address');

                if(!venue_title.toLowerCase().includes(searchTerm) && !venue_address.toLowerCase().includes(searchTerm)){
                    show = false;
                }
            }

            if (activeLocationFilters.length > 0) {
                let venue_location = venue_object.attr('data-location');
                if(!activeLocationFilters.includes(venue_location)){
                    show = false;
                }
            }

            if (activeSurfaceFilters.length > 0) {
                let venue_surface = venue_object.attr('data-surface');
                if(!activeSurfaceFilters.includes(venue_surface)){
                    show = false;
                }
            }

            if(show){
                venue_object.show();
            }

        })
    }

    // === EVENT LISTENERS ===

    // Search functionality
    $('#homepageSearchInput').on('input', function() {
        clearTimeout(window.searchTimeout);
        window.searchTimeout = setTimeout(filterVenues, 300);
    });

    // Filter checkboxes - use 'change' event which works better on mobile
    $('.location-filter, .surface-filter').on('change', function(e) {
        // Ensure the checkbox state is properly updated
        $(this).blur(); // Remove focus to prevent iOS issues
        filterVenues();
    });

    // Add click handler for labels to ensure mobile compatibility
    $('.form-check-label-custom').on('click', function(e) {
        e.preventDefault();
        const inputId = $(this).attr('for');
        const $input = $('#' + inputId);
        $input.prop('checked', !$input.prop('checked')).trigger('change');
    });

    // === USER ICON FUNCTIONALITY (nie je a href) ===
    $('.user-icon').on('click', function(e) {
        e.preventDefault();
        alert('Prihlásenie/Registrácia\n\nTu by sa otvorila prihlasovacia stránka.');
        // window.location.href = 'login.html';
    });

    // === INITIALIZATION ===


    // Fade in animation for cards
    $(document).on('scroll', function() {
        $('.venue-image-container').each(function() {
            const cardTop = $(this).offset().top;
            const cardHeight = $(this).height();
            const windowTop = $(window).scrollTop();
            const windowHeight = $(window).height();

            if (cardTop < windowTop + windowHeight - cardHeight * 0.1) {
                $(this).addClass('fade-in');
            }
        });
    });

    // === UTILITY FUNCTIONS ===

    // Debounce function for search
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Format opening hours for display
    function formatOpeningHours(hours) {
        const today = new Date().toLocaleLString('sk-SK', { weekday: 'long' });
        const todayHours = hours[today];
        return todayHours ? `Dnes: ${todayHours}` : 'Otváracie hodiny nie sú dostupné';
    }

});

// // === ADDITIONAL JQUERY PLUGINS/EXTENSIONS ===
//
// // Custom jQuery extension for sports venue filtering
// $.fn.filterSportsVenues = function(criteria) {
//     return this.filter(function() {
//         const $venue = $(this);
//         let matches = true;
//
//         if (criteria.location) {
//             matches = matches && $venue.data('location') === criteria.location;
//         }
//
//         if (criteria.type) {
//             matches = matches && $venue.data('type') === criteria.type;
//         }
//
//         if (criteria.search) {
//             const text = $venue.find('.venue-title').text().toLowerCase() +
//                 $venue.find('.venue-address').text().toLowerCase();
//             matches = matches && text.includes(criteria.search.toLowerCase());
//         }
//
//         return matches;
//     });
// };
